import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Inbox } from "lucide-react";
import Item from "./Item";
import { useScheduleContext } from "../../../../../../../hooks/context/useScheduleContext";
import { unassignedShiftsResource } from "../../../../../../../helpers/data/unassignedShiftsResource";

function UnassignedShifts({ hiddenEvents, close }: any) {
    const { t } = useTranslation();
    const { unassignedEvents } = useScheduleContext();

    const _unassignedEvents = useMemo(() => {
        const ids = hiddenEvents?.filter(
            (event: any) => event.resourceId === unassignedShiftsResource.id
        )?.map((item: any) => item.id);

        return unassignedEvents.filter((event: any) => (ids || []).includes(event.id));
    }, [hiddenEvents, unassignedEvents]);

    return _unassignedEvents?.length > 0
        ? (
            <div className="tw-pt-2 tw-pr-2">
                {_unassignedEvents.map((event: any) => (
                    <Item key={event.id} event={event} close={close} />
                ))}
            </div>
        ) : (
            <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-neutral-600 tw-py-7 tw-border tw-rounded-sm tw-border-dashed">
                <Inbox />
                {t("no-data")}
            </div>
        )
}

export default UnassignedShifts;
